import { Component } from "@angular/core";
import { SearchBoxDlgDelegate } from "../../../common";

@Component({
  selector: "items-search-box",
  templateUrl: "./items-search-box.html",
  standalone: false,
  inputs: ["searchCriteria"],
  outputs: ["searchCriteriaChanged"],
})
export class ItemSearchBox extends SearchBoxDlgDelegate {}
